import { alpha, Box, Grid, Typography, useTheme } from '@mui/material';
import { useCustomizations } from 'src/components/utils/theme/customizations';
import { SummaryPriceLines } from '../../summary/SummaryPriceLines';
import { SummaryPriceLineData } from '../../summary/summary-mapping';

import type { JSX } from 'react';

export interface IProps {
    header: string;
    lines: SummaryPriceLineData[];
    ensureSpaceForNumberOfLines: number;
}

export function CostSummary(props: IProps): JSX.Element {
    const { header, lines, ensureSpaceForNumberOfLines } = props;
    const { bookingWidgetColorContrast } = useCustomizations();
    const theme = useTheme();
    const numPaddedRows = Math.max(0, ensureSpaceForNumberOfLines - lines.length);
    const customizations = useCustomizations();

    return (
        <Box>
            <Typography
                component="h3"
                variant="h6"
                color={bookingWidgetColorContrast}
                mt={theme.spacing(2)}
                width={'100%'}
                borderBottom="1px solid"
                borderColor={alpha(bookingWidgetColorContrast, 0.2)}
            >
                {header}
            </Typography>
            <Grid mb={theme.spacing(3)} minHeight={`calc(2rem + ${theme.spacing(1)})`}>
                <SummaryPriceLines
                    invertedColorsClass={{
                        color: customizations.bookingWidgetColorContrast,
                    }}
                    lines={lines}
                />
                {new Array(numPaddedRows).fill(false).map((_x, i) => (
                    <Grid container justifyContent="space-between" key={i} pt={theme.spacing(1)}>
                        <Typography>&nbsp;</Typography>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
